import React, { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Box from "@mui/material/Box";
import FilledInput from "@mui/material/FilledInput";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import ImageParallax from "simple-parallax-js";
import emailjs from "@emailjs/browser";
import { uploadToCloudinary } from "../../Common";

// import SendIcon from '@mui/icons-material/Send';

import Button from "@mui/material/Button";
import "./career.style.css";
import { Heading } from "../../Components";
import { images } from "../../constants";

const Career = () => {
  const form = useRef();
  const [file, setFile] = useState(null);


  const sendForm = async (e) => {
    e.preventDefault();
  
    const fileUrl = await uploadToCloudinary(file);
  
    // Inject Cloudinary file URL into hidden input
    document.getElementById("file_url").value = fileUrl;
    
  
    // Remove file input before sending
    const removeInput = form.current.querySelector("#attachment");
    // removeInput
  
    // Send the form via EmailJS
    emailjs.sendForm("service_gpwns6e", "template_bthch3i", form.current, '5RoaEMrH0HU2MznT8')
      .then(() => {
        alert("Email Submitted!");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Failed to send email:", error);
        alert("Failed to send email.");
      })
      .finally(() => {
        // Restore the file input to the form
        // form.current.appendChild(originalFileInput);
      });
  };
    return (
    <div className="career">
      <div className="pageTitle">
        <h4>Career</h4>
      </div>

      <div className="content">
        <Heading title={"Build Career With Pom"} class={"my-5"} />

        <Container>
          <div className="formContent">
            <div className="bg">
              <ImageParallax orientation="down left">
                <img
                  src={images.company3}
                  alt="Banner Image"
                  className="bgImage"
                />
              </ImageParallax>
              <div className="bgOverlay"></div>
            </div>
            <Col lg={6} md={12} sm={12}>
              <form  ref={form} onSubmit={sendForm}>
                <Row>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        id="standard-required"
                        label="First Name"
                        fullWidth
                        variant="filled"
                        name="first_name"
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Last Name"
                        variant="filled"
                        name="last_name"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Email"
                        type="email"
                        variant="filled"
                        name="email"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Phone"
                        type="number"
                        variant="filled"
                        name="phone"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="City"
                        variant="filled"
                        name="city"
                      />
                    </div>
                  </Col>
                  {/* <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="CNIC"
                        type={"number"}
                        variant="filled"
                        name="cnic"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Recent Degree Acquired"
                        
                        variant="filled"
                        name="degree"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Area of Study"
                        variant="filled"
                        name="study"
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Years Of Experience"
                        variant="filled"
                        name="experience"
                      />
                    </div>
                  </Col> */}
                  <Col lg={6}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        required
                        fullWidth
                        id="standard-required"
                        label="Applying For the Post"
                        variant="filled"
                        name="post"
                      />
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="input d-flex align-items-center ">
                      <TextField
                        id="standard-multiline-static"
                        label="Message"
                        fullWidth
                        multiline
                        rows={4}
                        // defaultValue="Default Value"
                        variant="filled"
                        name="message"
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="input d-flex align-items-center ">
                      {/* <TextField
                        id="standard-multiline-static"
                        label="CV"
                        fullWidth
                        variant="filled"
                        name="file"
                        type="file"
                        required
                      /> */}
                      <Button variant="contained" color="primary" component="label" fullWidth>
                        Upload Cv : 
                        <input type="file"  id="attachment" className="px-2"  onChange={(e) => setFile(e.target.files[0])}  />
                        <input hidden name="file_link" id="file_url" />
                      </Button>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="input d-flex align-items-center ">
                      <Button variant="contained" type="submit" fullWidth>
                        Submit
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </Col>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Career;
